const iso = (d) => { const x = new Date(d); x.setMinutes(x.getMinutes() - x.getTimezoneOffset()); return x.toISOString().slice(0, 10); };
const add = (n) => { const d = new Date(); d.setDate(d.getDate() + n); return d; };
const nextDow = (dow) => { const d = new Date(); const diff = ((dow - d.getDay() + 7) % 7) || 7; return add(diff); };
const wd = (d) => d.toLocaleDateString(undefined, { weekday: "short" });

const BUILD = {
  0: () => ({ label: "Today", d: add(0) }),
  1: () => ({ label: "Tomorrow", d: add(1) }),
  3: () => { const d = add(3); return { label: "In 3 days", sub: wd(d), d }; },
  7: () => ({ label: "In a week", d: add(7) }),
  14: () => ({ label: "In 2 weeks", d: add(14) }),
  30: () => ({ label: "In a month", d: add(30) }),
  weekend: () => ({ label: "This weekend", d: [0, 6].includes(new Date().getDay()) ? add(0) : nextDow(6) }),
  monday: () => ({ label: "Next Monday", d: nextDow(1) }),
};

export const DatePresets = (keys) => {
  const seen = new Set();
  return keys.map((k) => ({ key: String(k), ...BUILD[k]() })).map((o) => ({ ...o, date: iso(o.d), full: o.d.toLocaleDateString(undefined, { weekday: "long", month: "long", day: "numeric" }) }))
    .filter((o) => (seen.has(o.date) ? false : seen.add(o.date)));
};
